import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { AppDispatch } from "@/app/store";
import { setToken, setRefreshToken } from "@/features/auth/slices/authSlice";

const LoginRedirect: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Parse the query string for ?token=... and ?refreshToken=...
    const params = new URLSearchParams(location.search);
    const tokenFromUrl = params.get("token");
    const refreshTokenFromUrl = params.get("refreshToken");

    // If both tokens exist, store them and go home
    if (tokenFromUrl && refreshTokenFromUrl) {
      dispatch(setToken(tokenFromUrl));
      dispatch(setRefreshToken(refreshTokenFromUrl));
      navigate("/");
    } else {
      // Otherwise, re-route to /login
      navigate("/login");
    }
  }, [dispatch, location, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <p>Processing your login link. Please wait...</p>
    </div>
  );
};

export default LoginRedirect;
